export default "__VITE_ASSET__c31ae917__"